export const INDIAN_STATES_AND_CITIES = {
  "Gujarat": [
    "Surat",
    "Ahmedabad",
    "Vadodara",
    "Rajkot",
    "Bhavnagar",
    "Jamnagar",
    "Gandhinagar",
    "Junagadh",
    "Anand",
    "Nadiad",
    "Navsari",
    "Morbi",
    "Bharuch",
    "Ankleshwar",
    "Valsad",
    "Vapi",
    "Porbandar",
    "Abdasa",
    "Ahwa",
    "Amod",
    "Amreli",
    "Anjar",
    "Babra",
    "Bagasara",
    "Balasinor",
    "Bardoli",
    "Barwala",
    "Bavla",
    "Bayad",
    "Bhabhar",
    "Bhachau",
    "Bhanvad",
    "Bhesan",
    "Bhiloda",
    "Bhuj",
    "Bilimora",
    "Bodeli",
    "Borsad",
    "Botad",
    "Chalala",
    "Chanasma",
    "Chhota Udepur",
    "Chikhli",
    "Choryasi",
    "Chotila",
    "Dabhoi",
    "Dahegam",
    "Dahod",
    "Damnagar",
    "Dantiwada",
    "Dediapada",
    "Deesa",
    "Desar",
    "Devgadh Baria",
    "Dhandhuka",
    "Dhanera",
    "Dhanpur",
    "Dhansura",
    "Dharampur",
    "Dharoi",
    "Dholka",
    "Dhoraji",
    "Dhrangadhra",
    "Dhrol",
    "Dolvan",
    "Dwarka",
    "Fatepura",
    "Gadhada",
    "Galteshwar",
    "Gandevi",
    "Gandhidham",
    "Garbada",
    "Gariadhar",
    "Garudeshwar",
    "Ghoghamba",
    "Gir Gadhada",
    "Godhra",
    "Gondal",
    "Halol",
    "Halvad",
    "Hansot",
    "Harij",
    "Himatnagar",
    "Idar",
    "Jafrabad",
    "Jalalpore",
    "Jambughoda",
    "Jambusar",
    "Jamjodhpur",
    "Jasdan",
    "Jetpur",
    "Jhagadia",
    "Jhalod",
    "Jodiya",
    "Kadi",
    "Kalavad",
    "Kalol (Gandhinagar)",
    "Kalol (Panchmahal)",
    "Kalyanpur",
    "Kamrej",
    "Kapadvanj",
    "Kaprada",
    "Karjan",
    "Kathlal",
    "Kavant",
    "Keshod",
    "Khambhalia",
    "Khambhat",
    "Kheda",
    "Khedbrahma",
    "Kheralu",
    "Khergam",
    "Kodinar",
    "Kukarmunda",
    "Kutiyana",
    "Lakhani",
    "Lakhpat",
    "Lalpur",
    "Lathi",
    "Limbdi",
    "Limkheda",
    "Lunawada",
    "Mahudha",
    "Mahuva (Bhavnagar)",
    "Mahuva (Surat)",
    "Malia Hatina",
    "Malpur",
    "Manavadar",
    "Mandal",
    "Mandvi (Kutch)",
    "Mangrol (Junagadh)",
    "Mangrol (Surat)",
    "Mansa",
    "Matar",
    "Meghraj",
    "Mehsana",
    "Mendarda",
    "Modasa",
    "Morva Hadaf",
    "Mundra",
    "Nakhtrana",
    "Nandod",
    "Nasvadi",
    "Netrang",
    "Nizar",
    "Olpad",
    "Padra",
    "Palanpur",
    "Palitana",
    "Palsana",
    "Pardi",
    "Patan",
    "Pavijetpur",
    "Petlad",
    "Prantij",
    "Radhanpur",
    "Rajpipla",
    "Rajula",
    "Ranavav",
    "Ranpur",
    "Rapar",
    "Sagbara",
    "Sami",
    "Sanand",
    "Sanjeli",
    "Sankheda",
    "Santalpur",
    "Santrampur",
    "Savarkundla",
    "Savli",
    "Shankheshwar",
    "Shehra",
    "Shinor",
    "Siddhpur",
    "Sihor",
    "Singvad",
    "Sojitra",
    "Somnath",
    "Songadh",
    "Songadh (Bhavnagar)",
    "Subir",
    "Suigam",
    "Surendranagar",
    "Sutrapada",
    "Talaja",
    "Talala",
    "Talod",
    "Tarapur",
    "Thangadh",
    "Tharad",
    "Thasra",
    "Tilakwada",
    "Uchchhal",
    "Umarpada",
    "Umbergaon",
    "Umreth",
    "Una",
    "Unjha",
    "Upleta",
    "Vadgam",
    "Vadnagar",
    "Vagra",
    "Valia",
    "Vallabhipur",
    "Valod",
    "Vansda",
    "Vanthali",
    "Vaso",
    "Vav",
    "Veraval",
    "Vijapur",
    "Viramgam",
    "Visavadar",
    "Visnagar",
    "Vyara",
    "Wadhwan",
    "Waghai",
    "Waghodia",
    "Wankaner"
  ],
  "Maharashtra": [
    "Mumbai",
    "Pune",
    "Nagpur",
    "Thane",
    "Nashik",
    "Chhatrapati Sambhajinagar",
    "Solapur",
    "Kolhapur",
    "Navi Mumbai",
    "Kalyan-Dombivli",
    "Vasai-Virar",
    "Achalpur",
    "Aheri",
    "Ahmednagar",
    "Ahmedpur",
    "Ajra",
    "Akkalkot",
    "Akola",
    "Akole",
    "Akot",
    "Alibag",
    "Amalner",
    "Ambad",
    "Ambejogai",
    "Ambernath",
    "Amgaon",
    "Amravati",
    "Anjangaon Surji",
    "Armori",
    "Arni",
    "Arvi",
    "Ashti (Beed)",
    "Ashti (Wardha)",
    "Aundha Nagnath",
    "Ausa",
    "Badlapur",
    "Badnapur",
    "Balapur",
    "Ballarpur",
    "Baramati",
    "Barshi",
    "Barshitakli",
    "Basmath",
    "Beed",
    "Bhadravati",
    "Bhandara",
    "Bhiwandi",
    "Bhokardan",
    "Bhoom",
    "Bhor",
    "Bhusawal",
    "Biloli",
    "Bodwad",
    "Brahmapuri",
    "Buldhana",
    "Chakan",
    "Chakur",
    "Chalisgaon",
    "Chamorshi",
    "Chandgad",
    "Chandrapur",
    "Chandur Bazar",
    "Chandur Railway",
    "Chandwad",
    "Chikhli (Buldhana)",
    "Chimur",
    "Chiplun",
    "Chopda",
    "Darwha",
    "Daryapur",
    "Daund",
    "Degloor",
    "Deola",
    "Deoli",
    "Desaiganj (Wadsa)",
    "Deulgaon Raja",
    "Dhamangaon",
    "Dharangaon",
    "Dharashiv (Osmanabad)",
    "Dharmabad",
    "Dharur",
    "Dhule",
    "Digras",
    "Dindori",
    "Dondaicha",
    "Erandol",
    "Faizpur",
    "Gadchiroli",
    "Gadhinglaj",
    "Gangakhed",
    "Gangapur",
    "Georai",
    "Ghatanji",
    "Gondia",
    "Goregaon (Gondia)",
    "Hadgaon",
    "Himayatnagar",
    "Hinganghat",
    "Hingoli",
    "Ichalkaranji",
    "Indapur",
    "Islampur",
    "Jafrabad",
    "Jalgaon",
    "Jalgaon Jamod",
    "Jalna",
    "Jamkhed",
    "Jamner",
    "Jaysingpur",
    "Jintur",
    "Junnar",
    "Kagal",
    "Kaij",
    "Kalamb",
    "Kalamnuri",
    "Kalmeshwar",
    "Kalwan",
    "Kamthi",
    "Kandhar",
    "Kankavli",
    "Kannad",
    "Karad",
    "Karanja Lad",
    "Karjat",
    "Karjat (Ahmednagar)",
    "Karmala",
    "Katol",
    "Khamgaon",
    "Khed (Rajgurunagar)",
    "Khopoli",
    "Khuldabad",
    "Kinwat",
    "Kopargaon",
    "Koregaon",
    "Kudal",
    "Kurundwad",
    "Lakhani",
    "Lasalgaon",
    "Latur",
    "Loha",
    "Lonavala",
    "Madha",
    "Mahabaleshwar",
    "Mahad",
    "Majalgaon",
    "Malegaon",
    "Malegaon (Washim)",
    "Malkapur (Buldhana)",
    "Malkapur (Kolhapur)",
    "Malvan",
    "Manchar",
    "Mangalwedha",
    "Mangaon",
    "Mangrulpir",
    "Manora",
    "Manwath",
    "Mehkar",
    "Mira-Bhayandar",
    "Miraj",
    "Mohadi",
    "Mohol",
    "Morshi",
    "Mudkhed",
    "Mukhed",
    "Muktainagar",
    "Mul",
    "Murtizapur",
    "Nagbhir",
    "Nanded",
    "Nandgaon",
    "Nandgaon Khandeshwar",
    "Nandura",
    "Nandurbar",
    "Narkhed",
    "Navapur",
    "Ner",
    "Nevasa",
    "Nilanga",
    "Niphad",
    "Omerga",
    "Ozar",
    "Pachora",
    "Paithan",
    "Pandharkawada",
    "Pandharpur",
    "Panhala",
    "Panvel",
    "Paranda",
    "Parbhani",
    "Parli Vaijnath",
    "Parner",
    "Parola",
    "Partur",
    "Pathardi",
    "Pathri",
    "Patur",
    "Pauni",
    "Pen",
    "Phaltan",
    "Phulambri",
    "Pulgaon",
    "Purna",
    "Pusad",
    "Radhanagari",
    "Rahimatpur",
    "Rahuri",
    "Rajura",
    "Ralegaon",
    "Ramtek",
    "Ratnagiri",
    "Raver",
    "Renapur",
    "Risod",
    "Roha",
    "Sailu",
    "Sakoli",
    "Sangamner",
    "Sangli",
    "Sangola",
    "Saswad",
    "Satana",
    "Satara",
    "Savner",
    "Sawantwadi",
    "Seloo",
    "Shahada",
    "Shegaon",
    "Shevgaon",
    "Shirala",
    "Shirdi",
    "Shirpur",
    "Shirur",
    "Shrirampur",
    "Sillod",
    "Sindi",
    "Sinnar",
    "Sonpeth",
    "Talegaon Dabhade",
    "Taloda",
    "Tasgaon",
    "Telhara",
    "Tirora",
    "Tuljapur",
    "Tumsar",
    "Udgir",
    "Ulhasnagar",
    "Umarkhed",
    "Umred",
    "Umri",
    "Vaijapur",
    "Vengurla",
    "Vita",
    "Wai",
    "Wani",
    "Wardha",
    "Warora",
    "Warud",
    "Washim",
    "Yavatmal",
    "Yawal",
    "Yeola"
  ],
  "Rajasthan": [
    "Abu Road",
    "Ajmer",
    "Aklera",
    "Alwar",
    "Anupgarh",
    "Bali",
    "Balotra",
    "Bandikui",
    "Banswara",
    "Baran",
    "Bari",
    "Barmer",
    "Bayana",
    "Beawar",
    "Behror",
    "Bhadra",
    "Bharatpur",
    "Bhawani Mandi",
    "Bhilwara",
    "Bhiwadi",
    "Bikaner",
    "Bundi",
    "Chhabra",
    "Chittorgarh",
    "Chomu",
    "Churu",
    "Dausa",
    "Deeg",
    "Degana",
    "Deoli",
    "Dholpur",
    "Didwana",
    "Dudu",
    "Dungarpur",
    "Fatehpur (Rajasthan)",
    "Gangapur City",
    "Gulabpura",
    "Hanumangarh",
    "Hindaun",
    "Jaipur",
    "Jaisalmer",
    "Jaitaran",
    "Jalore",
    "Jayal",
    "Jhalawar",
    "Jhalrapatan",
    "Jhunjhunu",
    "Jobner",
    "Jodhpur",
    "Kailadevi",
    "Kaman",
    "Kankroli",
    "Kapasan",
    "Karauli",
    "Kekri",
    "Khairthal",
    "Kishangarh",
    "Kishangarh Renwal",
    "Kota",
    "Kotputli",
    "Kuchaman",
    "Ladnun",
    "Lalsot",
    "Mahwa",
    "Makrana",
    "Malpura",
    "Mandalgarh",
    "Merta City",
    "Mount Abu",
    "Nadbai",
    "Nagaur",
    "Nathdwara",
    "Nawalgarh",
    "Neemrana",
    "Nimbahera",
    "Niwai",
    "Nohar",
    "Pali",
    "Palsana (Rajasthan)",
    "Parbatsar",
    "Phalodi",
    "Phulera",
    "Pilasani",
    "Pindwara",
    "Pratapgarh",
    "Rajakhera",
    "Rajgarh (Churu)",
    "Rajsamand",
    "Ratangarh",
    "Rawatbhata",
    "Sadri",
    "Salumbar",
    "Sambhar",
    "Sanchore",
    "Sardarshahar",
    "Sawai Madhopur",
    "Shahpura",
    "Shahpura (Bhilwara)",
    "Sheoganj",
    "Sikar",
    "Sirohi",
    "Sojat",
    "Sri Ganganagar",
    "Sujangarh",
    "Sumerpur",
    "Suratgarh",
    "Tijara",
    "Todabhim",
    "Tonk",
    "Udaipur",
    "Weir"
  ],
  "Delhi": [
    "Central Delhi",
    "Chanakyapuri",
    "Chandni Chowk",
    "Civil Lines",
    "Connaught Place",
    "Dwarka",
    "East Delhi",
    "Hauz Khas",
    "Janakpuri",
    "Karol Bagh",
    "Lajpat Nagar",
    "Laxmi Nagar",
    "Mayur Vihar",
    "Najafgarh",
    "Narela",
    "Nehru Place",
    "New Delhi",
    "North Delhi",
    "North East Delhi",
    "North West Delhi",
    "Okhla",
    "Paschim Vihar",
    "Pitampura",
    "Punjabi Bagh",
    "Rohini",
    "Saket",
    "Shahdara",
    "South Delhi",
    "South East Delhi",
    "South West Delhi",
    "Vasant Kunj",
    "West Delhi"
  ],
  "Madhya Pradesh": [
    "Agar Malwa",
    "Alirajpur",
    "Alot",
    "Amarpatan",
    "Ambah",
    "Amla",
    "Anuppur",
    "Aron",
    "Ashoknagar",
    "Ashta",
    "Badnawar",
    "Balaghat",
    "Barwaha",
    "Barwani",
    "Betul",
    "Bhind",
    "Bhopal",
    "Biaora",
    "Bijuri",
    "Bina-Etawa",
    "Burhanpur",
    "Chhatarpur",
    "Chhindwara",
    "Chitrakoot (Satna)",
    "Dabra",
    "Damoh",
    "Datia",
    "Deori",
    "Depalpur",
    "Dewas",
    "Dhar",
    "Dindori",
    "Gadarwara",
    "Ganjbasoda",
    "Garhakota",
    "Gohad",
    "Guna",
    "Gwalior",
    "Harda",
    "Hoshangabad (Narmadapuram)",
    "Indore",
    "Itarsi",
    "Jabalpur",
    "Jaora",
    "Jhabua",
    "Joura",
    "Kareli",
    "Karera",
    "Khandwa",
    "Khargone",
    "Khurai",
    "Kolaras",
    "Kotma",
    "Kukshi",
    "Kurwai",
    "Lahar",
    "Lalitpur Border Area",
    "Maheshwar",
    "Maihar",
    "Manawar",
    "Mandla",
    "Mandsaur",
    "Mauganj",
    "Mehgaon",
    "Mhow (Dr. Ambedkar Nagar)",
    "Morena",
    "Multai",
    "Murwara (Katni)",
    "Nagda",
    "Nagod",
    "Narsinghgarh",
    "Narsinghpur",
    "Nasrullaganj",
    "Neemuch",
    "Niwari",
    "Pandhurna",
    "Panna",
    "Pichhore",
    "Pipariya",
    "Pithampur",
    "Porsa",
    "Raghogarh",
    "Raisen",
    "Rajgarh",
    "Rampur Baghelan",
    "Ratlam",
    "Rau",
    "Rehli",
    "Rewa",
    "Sabalgarh",
    "Sagar",
    "Sanawad",
    "Sanwer",
    "Sarangpur",
    "Sarni",
    "Satna",
    "Sehore",
    "Sendhwa",
    "Seoni",
    "Shahdol",
    "Shajapur",
    "Sheopur",
    "Shivpuri",
    "Shujalpur",
    "Sidhi",
    "Singrauli",
    "Sironj",
    "Tikamgarh",
    "Ujjain",
    "Umaria",
    "Vidisha",
    "Waidhan"
  ],
  "Uttar Pradesh": [
    "Agra",
    "Ahraura",
    "Akbarpur",
    "Aligarh",
    "Amethi",
    "Amroha",
    "Anpara",
    "Anupshahr",
    "Atarra",
    "Auraiya",
    "Ayodhya (Faizabad)",
    "Azamgarh",
    "Baberu",
    "Babina",
    "Bachhrawan",
    "Badlapur (Jaunpur)",
    "Baghpat",
    "Bahraich",
    "Bairia",
    "Ballia",
    "Balrampur",
    "Banda",
    "Bangarmau",
    "Bansdih",
    "Bansgaon",
    "Bansi",
    "Barabanki",
    "Bareilly",
    "Barhaj",
    "Basti",
    "Bela Pratapgarh",
    "Bhadohi",
    "Bharthana",
    "Bhatpar Rani",
    "Bhinga",
    "Bidhuna",
    "Bijnor",
    "Bikapur",
    "Bilgram",
    "Bilsi",
    "Bindki",
    "Bisalpur",
    "Biswan",
    "Budaun",
    "Bulandshahr",
    "Chail",
    "Chakia",
    "Chandauli",
    "Chandausi",
    "Chandpur",
    "Charkhari",
    "Chhibramau",
    "Chitrakoot",
    "Chunar",
    "Colonelganj",
    "Dataganj",
    "Debai",
    "Deoria",
    "Dhampur",
    "Dhanaura",
    "Dibiyapur",
    "Domariyaganj",
    "Etawah",
    "Farrukhabad",
    "Fatehpur",
    "Fatehpur Chaurasi",
    "Firozabad",
    "Gajraula",
    "Gauriganj",
    "Ghaziabad",
    "Ghazipur",
    "Ghosi",
    "Gola Gokarannath",
    "Gonda",
    "Gopiganj",
    "Gorakhpur",
    "Greater Noida",
    "Gulothi",
    "Gursahaiganj",
    "Gursarai",
    "Gyanpur",
    "Hamirpur",
    "Hapur",
    "Hardoi",
    "Harraiya",
    "Hasanpur",
    "Hata",
    "Hathras",
    "Itwa",
    "Jahangirabad",
    "Jais",
    "Jalalabad",
    "Jalalpur",
    "Jalaun",
    "Jarwal",
    "Jaswantnagar",
    "Jaunpur",
    "Jhansi",
    "Kachhwa",
    "Kadipur",
    "Kaimganj",
    "Kakrala",
    "Kalpi",
    "Kannauj",
    "Kanpur",
    "Kaptanganj",
    "Karwi",
    "Kasganj",
    "Kaushambi",
    "Kerakat",
    "Khaga",
    "Khairabad",
    "Khalilabad",
    "Kheri",
    "Khurja",
    "Kiratpur",
    "Konch",
    "Kosi Kalan",
    "Kulpahar",
    "Kunda",
    "Kushinagar",
    "Laharpur",
    "Lakhimpur",
    "Lalganj (Raebareli)",
    "Lalitpur",
    "Lucknow",
    "Machhlishahr",
    "Madhogarh",
    "Madhuban",
    "Maharajganj",
    "Mahmudabad",
    "Mahoba",
    "Mallawan",
    "Manjhanpur",
    "Mankapur",
    "Mariahu",
    "Mathura",
    "Mau",
    "Maudaha",
    "Maunath Bhanjan",
    "Mauranipur",
    "Meerut",
    "Mehdawal",
    "Mirzapur",
    "Modinagar",
    "Mohammadabad (Ghazipur)",
    "Mohammadi",
    "Moradabad",
    "Mughalsarai (Pt. Deen Dayal Upadhyaya Nagar)",
    "Muhammadabad",
    "Musafirkhana",
    "Muzaffarnagar",
    "Nagina",
    "Najibabad",
    "Nanpara",
    "Naraini",
    "Naugarh",
    "Nautanwa",
    "Nawabganj",
    "Nichlaul",
    "Noida",
    "Obra",
    "Orai",
    "Padrauna",
    "Palia Kalan",
    "Patti",
    "Pharenda",
    "Pilibhit",
    "Powayan",
    "Pratapgarh",
    "Prayagraj (Allahabad)",
    "Puranpur",
    "Raebareli",
    "Rampur",
    "Rasra",
    "Rath",
    "Renukoot",
    "Robertsganj",
    "Rudauli",
    "Rudrapur (Deoria)",
    "Saharanpur",
    "Sahaswan",
    "Saidpur",
    "Salempur",
    "Sambhal",
    "Sandila",
    "Sant Kabir Nagar",
    "Shahabad (Hardoi)",
    "Shahganj",
    "Shahjahanpur",
    "Shamli",
    "Shamsabad",
    "Shikohabad",
    "Shravasti",
    "Shuklaganj",
    "Siddharthnagar",
    "Sidhauli",
    "Sikandrabad",
    "Sirathu",
    "Sirsaganj",
    "Sitapur",
    "Sonbhadra",
    "Sultanpur",
    "Tanda (Ambedkar Nagar)",
    "Tarabganj",
    "Tilhar",
    "Tundla",
    "Ujhani",
    "Unnao",
    "Utraula",
    "Varanasi",
    "Vrindavan",
    "Zamania"
  ],
  "Karnataka": [
    "Aland",
    "Ankola",
    "Arkalgud",
    "Arsikere",
    "Athani",
    "Badami",
    "Bagalkote",
    "Bagepalli",
    "Bailhongal",
    "Ballari",
    "Bangarapet",
    "Bantwal",
    "Basavakalyan",
    "Belagavi",
    "Belthangady",
    "Belur",
    "Bengaluru",
    "Bhadravati",
    "Bhalki",
    "Bhatkal",
    "Bidar",
    "Brahmavar",
    "Byndoor",
    "Challakere",
    "Chamarajanagar",
    "Channagiri",
    "Channapatna",
    "Channarayapatna",
    "Chikkaballapura",
    "Chikkamagaluru",
    "Chikkodi",
    "Chincholi",
    "Chintamani",
    "Chitradurga",
    "Dandeli",
    "Davanagere",
    "Gadag",
    "Gangavati",
    "Gauribidanur",
    "Gokak",
    "Gubbi",
    "Guledgudda",
    "Gundlupet",
    "Haliyal",
    "Harapanahalli",
    "Harihar",
    "Hassan",
    "Heggadadevankote",
    "Hiriyur",
    "Holalkere",
    "Holenarasipura",
    "Honavar",
    "Honnali",
    "Hosadurga",
    "Hosapete",
    "Hubballi-Dharwad",
    "Humnabad",
    "Hunsur",
    "Ilkal",
    "Jamkhandi",
    "Joida",
    "Kadaba",
    "Kadur",
    "Kalaburagi",
    "Kampli",
    "Kanakapura",
    "Karkala",
    "Karwar",
    "Kaup",
    "KGF (Kolar Gold Fields)",
    "Kolar",
    "Kollegal",
    "Koppa",
    "Koppal",
    "Kotturu",
    "Krishnarajpet",
    "Kudligi",
    "Kumta",
    "Kundapura",
    "Kunigal",
    "Kushalnagar",
    "Kushtagi",
    "Lingasugur",
    "Maddur",
    "Madhugiri",
    "Madikeri",
    "Magadi",
    "Malavalli",
    "Malur",
    "Mandya",
    "Mangaluru",
    "Manvi",
    "Moodabidri",
    "Mudgal",
    "Mudhol",
    "Mudigere",
    "Mulbagal",
    "Mysuru",
    "Nagamangala",
    "Nanjangud",
    "Narasimharajapura",
    "Nipani",
    "Pandavapura",
    "Pavagada",
    "Piriyapatna",
    "Puttur",
    "Raichur",
    "Ramanagara",
    "Ranebennuru",
    "Robertsonpet",
    "Sagar",
    "Sakleshpur",
    "Sandur",
    "Saundatti",
    "Sedam",
    "Shahabad",
    "Shahapur",
    "Shikaripur",
    "Shivamogga",
    "Shorapur",
    "Sidlaghatta",
    "Sindhanur",
    "Sira",
    "Sirsi",
    "Somwarpet",
    "Sorab",
    "Sringeri",
    "Srinivaspur",
    "Srirangapatna",
    "Sullia",
    "T. Narasipura",
    "Tarikere",
    "Thirthahalli",
    "Tiptur",
    "Tumakuru",
    "Udupi",
    "Vijayapura",
    "Virajpet",
    "Wadi",
    "Yadgir",
    "Yelburga",
    "Yellapur"
  ],
  "Tamil Nadu": [
    "Ambasamudram",
    "Ambur",
    "Arakkonam",
    "Arani",
    "Ariyalur",
    "Aruppukkottai",
    "Attur",
    "Avadi",
    "Avanashi",
    "Bhavani",
    "Bodinayakanur",
    "Chengalpattu",
    "Chennai",
    "Cheyyar",
    "Chidambaram",
    "Coimbatore",
    "Colachel",
    "Coonoor",
    "Cuddalore",
    "Cumbum",
    "Dharapuram",
    "Dharmapuri",
    "Dindigul",
    "Edappadi",
    "Erode",
    "Gingee",
    "Gobichettipalayam",
    "Gudalur",
    "Gudiyatham",
    "Gummidipoondi",
    "Hosur",
    "Kadayanallur",
    "Kallakurichi",
    "Kanchipuram",
    "Kangeyam",
    "Kanniyakumari",
    "Karur",
    "Kaveripattinam",
    "Kayalpattinam",
    "Kodaikanal",
    "Komarapalayam",
    "Kotagiri",
    "Kovilpatti",
    "Krishnagiri",
    "Kumbakonam",
    "Kuzhithurai",
    "Lalgudi",
    "Madurai",
    "Manapparai",
    "Mannargudi",
    "Mayiladuthurai",
    "Mettupalayam",
    "Mettur",
    "Musiri",
    "Nagapattinam",
    "Nagercoil",
    "Namakkal",
    "Neyveli",
    "Padmanabhapuram",
    "Palani",
    "Palladam",
    "Panruti",
    "Paramathi Velur",
    "Pattukkottai",
    "Perambalur",
    "Periyakulam",
    "Perundurai",
    "Pollachi",
    "Polur",
    "Ponneri",
    "Pudukkottai",
    "Puliyankudi",
    "Rajapalayam",
    "Ranipet",
    "Rasipuram",
    "Salem",
    "Sankagiri",
    "Sankarankovil",
    "Sathyamangalam",
    "Sattur",
    "Sirkazhi",
    "Sivakasi",
    "Srivilliputhur",
    "Tambaram",
    "Tenkasi",
    "Thanjavur",
    "Theni Allinagaram",
    "Thiruthuraipoondi",
    "Thiruvaiyaru",
    "Thiruvarur",
    "Thoothukudi",
    "Thuraiyur",
    "Tindivanam",
    "Tiruchendur",
    "Tiruchengode",
    "Tiruchirappalli",
    "Tirunelveli",
    "Tirupathur",
    "Tiruppur",
    "Tiruttani",
    "Tiruvannamalai",
    "Udhagamandalam (Ooty)",
    "Udumalaipettai",
    "Uthamapalayam",
    "Valliyur",
    "Valparai",
    "Vandavasi",
    "Vaniyambadi",
    "Vedaranyam",
    "Vellore",
    "Villupuram",
    "Virudhunagar",
    "Vridhachalam"
  ],
  "Telangana": [
    "Achampet",
    "Adilabad",
    "Alair",
    "Alampur",
    "Armoor",
    "Asifabad",
    "Badepally",
    "Banswada",
    "Bellampalli",
    "Bellampally",
    "Bhadrachalam",
    "Bhongir",
    "Bhupalpally",
    "Bhuvanagiri",
    "Bodhan",
    "Chennur",
    "Choutuppal",
    "Devarakonda",
    "Dornakal",
    "Dubbak",
    "Gadwal",
    "Gajwel",
    "Husnabad",
    "Huzurabad",
    "Huzurnagar",
    "Hyderabad",
    "Jadcherla",
    "Jagtial",
    "Jammikunta",
    "Jangaon",
    "Kagaznagar",
    "Kalwakurthy",
    "Kamareddy",
    "Karimnagar",
    "Khammam",
    "Kodad",
    "Kollapur",
    "Koratla",
    "Kosgi",
    "Kothagudem",
    "Kyathanpally",
    "Mahabubabad",
    "Mahbubnagar",
    "Makthal",
    "Mancherial",
    "Mandamarri",
    "Manthani",
    "Manuguru",
    "Maripeda",
    "Medak",
    "Metpalli",
    "Miryalaguda",
    "Mothkur",
    "Nagarkurnool",
    "Nalgonda",
    "Narayanpet",
    "Narsampet",
    "Nirmal",
    "Nizamabad",
    "Palakurthy",
    "Palwancha",
    "Parkal",
    "Peddapalli",
    "Raikal",
    "Ramagundam",
    "Sangareddy",
    "Shadnagar",
    "Siddipet",
    "Sircilla",
    "Station Ghanpur",
    "Sultanabad",
    "Suryapet",
    "Tandur",
    "Thorrur",
    "Vemulawada",
    "Vikarabad",
    "Wanaparthy",
    "Warangal",
    "Wardhannapet",
    "Yellandu",
    "Zaheerabad"
  ],
  "Andhra Pradesh": [
    "Adoni",
    "Allagadda",
    "Amadalavalasa",
    "Amalapuram",
    "Amaravati",
    "Anakapalle",
    "Anantapur",
    "Atmakur (Kurnool)",
    "Atmakur (Nellore)",
    "Badvel",
    "Banaganapalle",
    "Bapatla",
    "Bheemunipatnam",
    "Bhimavaram",
    "Bobbili",
    "Chilakaluripet",
    "Chirala",
    "Chittoor",
    "Dharmavaram",
    "Dhone",
    "Eluru",
    "Giddalur",
    "Gooty",
    "Gudivada",
    "Gudur",
    "Guntakal",
    "Guntur",
    "Hindupur",
    "Ichchapuram",
    "Jammalamadugu",
    "Kadapa",
    "Kadiri",
    "Kakinada",
    "Kalyandurg",
    "Kandukur",
    "Kanigiri",
    "Kavali",
    "Kovvur",
    "Kuppam",
    "Kurnool",
    "Macherla",
    "Machilipatnam",
    "Madanapalle",
    "Mandapeta",
    "Mangalagiri",
    "Markapur",
    "Mydukur",
    "Nagari",
    "Naidupet",
    "Nandikotkur",
    "Nandyal",
    "Narasaraopet",
    "Narsipatnam",
    "Nellore",
    "Nidadavole",
    "Ongole",
    "Palakollu",
    "Palamaner",
    "Palasa-Kasibugga",
    "Parvathipuram",
    "Peddapuram",
    "Penukonda",
    "Piduguralla",
    "Pithapuram",
    "Ponnur",
    "Proddatur",
    "Pulivendula",
    "Punganur",
    "Puttaparthi",
    "Puttur (Andhra)",
    "Rajamahendravaram",
    "Rajampet",
    "Ramachandrapuram",
    "Ravulapalem",
    "Rayachoti",
    "Rayadurg",
    "Repalle",
    "Salur",
    "Samalkota",
    "Sattenapalle",
    "Sompeta",
    "Srikakulam",
    "Srikalahasti",
    "Sullurpeta",
    "Tadepalligudem",
    "Tadipatri",
    "Tanuku",
    "Tekkali",
    "Tenali",
    "Tirupati",
    "Tuni",
    "Venkatagiri",
    "Vijayawada",
    "Vinukonda",
    "Visakhapatnam",
    "Vizianagaram",
    "Yelamanchili",
    "Yemmiganur",
    "Yerraguntla"
  ],
  "West Bengal": [
    "Alipurduar",
    "Amta",
    "Andal",
    "Arambagh",
    "Asansol",
    "Bagnan",
    "Baharampur",
    "Baidyabati",
    "Balarampur",
    "Balurghat",
    "Bangaon",
    "Bankura",
    "Barasat",
    "Bardhaman",
    "Barrackpore",
    "Baruipur",
    "Basirhat",
    "Beldanga",
    "Bhadreswar",
    "Bhatpara",
    "Bishnupur (Bankura)",
    "Bolpur",
    "Budge Budge",
    "Canning",
    "Chakdaha",
    "Chanchal",
    "Chandannagar",
    "Chandrakona",
    "Chinsurah",
    "Contai (Kanthi)",
    "Cooch Behar",
    "Dankuni",
    "Darjeeling",
    "Dhulian",
    "Dhupguri",
    "Diamond Harbour",
    "Dinhata",
    "Durgapur",
    "Egra",
    "Falakata",
    "Gangarampur",
    "Garbeta",
    "Ghatal",
    "Guskara",
    "Habra",
    "Haldia",
    "Howrah",
    "Islampur (Uttar Dinajpur)",
    "Jalpaiguri",
    "Jamuria",
    "Jangipur",
    "Jhalda",
    "Jhargram",
    "Kakdwip",
    "Kaliaganj",
    "Kalimpong",
    "Kalna",
    "Kalyani",
    "Kanchrapara",
    "Kandi",
    "Katwa",
    "Kharagpur",
    "Kharar",
    "Khatra",
    "Kolkata",
    "Krishnanagar",
    "Kulti",
    "Kurseong",
    "Lalgola",
    "Malbazar",
    "Malda",
    "Mathabhanga",
    "Maynaguri",
    "Memari",
    "Midnapore",
    "Mirik",
    "Nabadwip",
    "Naihati",
    "Purulia",
    "Raghunathpur",
    "Raiganj",
    "Ramjibanpur",
    "Rampurhat",
    "Ranaghat",
    "Raniganj",
    "Rishra",
    "Samsi",
    "Serampore",
    "Shantipur",
    "Siliguri",
    "Sonamukhi",
    "Sonarpur",
    "Suri",
    "Tamluk",
    "Tarakeswar",
    "Tehatta",
    "Tufanganj",
    "Uluberia"
  ],
  "Punjab": [
    "Abohar",
    "Ahmedgarh",
    "Amloh",
    "Amritsar",
    "Anandpur Sahib",
    "Balachaur",
    "Banga",
    "Bareta",
    "Barnala",
    "Bassi Pathana",
    "Batala",
    "Bathinda",
    "Bhikhi",
    "Bholath",
    "Budhlada",
    "Chabhal",
    "Chamkaur Sahib",
    "Dasuya",
    "Dera Baba Nanak",
    "Dera Bassi",
    "Dhuri",
    "Dinanagar",
    "Doraha",
    "Fatehgarh Sahib",
    "Fazilka",
    "Firozpur",
    "Garhshankar",
    "Gidderbaha",
    "Gurdaspur",
    "Guru Har Sahai",
    "Hoshiarpur",
    "Jagraon",
    "Jalalabad",
    "Jalandhar",
    "Kapurthala",
    "Kartarpur",
    "Khadur Sahib",
    "Khanna",
    "Kharar",
    "Kurali",
    "Lalru",
    "Lehragaga",
    "Ludhiana",
    "Malerkotla",
    "Malout",
    "Mandi Gobindgarh",
    "Mansa",
    "Moga",
    "Mohali (SAS Nagar)",
    "Moonak",
    "Morinda",
    "Mukerian",
    "Muktsar",
    "Nabhab",
    "Nakodar",
    "Nangal",
    "Nawanshahr (Shaheed Bhagat Singh Nagar)",
    "Pathankot",
    "Patiala",
    "Patran",
    "Patti",
    "Phagwara",
    "Phillaur",
    "Qadian",
    "Raikot",
    "Rajpura",
    "Rampura Phul",
    "Rupnagar (Ropar)",
    "Samana",
    "Samrala",
    "Sangrur",
    "Sardulgarh",
    "Shahkot",
    "Sirhind",
    "Sultanpur Lodhi",
    "Sunam",
    "Talwandi Sabo",
    "Tanda Urmar",
    "Tarn Taran",
    "Zira",
    "Zirakpur"
  ],
  "Haryana": [
    "Ambala",
    "Ambala Cantt",
    "Assandh",
    "Badhra",
    "Bahadurgarh",
    "Ballabhgarh",
    "Barara",
    "Barwala (Hisar)",
    "Bawal",
    "Bawani Khera",
    "Beri",
    "Bhiwani",
    "Bhuna",
    "Bilaspur (Haryana)",
    "Charkhi Dadri",
    "Cheeka (Guhla)",
    "Chhachhrauli",
    "Dabwali",
    "Dharuhera",
    "Ellenabad",
    "Faridabad",
    "Farrukhnagar",
    "Fatehabad",
    "Gannaur",
    "Gharaunda",
    "Gohana",
    "Gurugram (Gurgaon)",
    "Hansi",
    "Hathin",
    "Hisar",
    "Hodal",
    "Indri",
    "Ismailabad",
    "Israna",
    "Jagadhri",
    "Jhajjar",
    "Jind",
    "Julana",
    "Kaithal",
    "Kalanaur",
    "Kalanwali",
    "Kalayat",
    "Kalka",
    "Kanina",
    "Karnal",
    "Kharkhoda",
    "Kosli",
    "Kundli",
    "Ladwa",
    "Loharu",
    "Madlauda",
    "Mahendragarh",
    "Manesar",
    "Meham",
    "Naraingarh",
    "Narnaul",
    "Narnaund",
    "Narwana",
    "Nilokheri",
    "Nuh",
    "Palwal",
    "Panchkula",
    "Panipat",
    "Pataudi",
    "Pehowa",
    "Pinjore",
    "Pundri",
    "Radaur",
    "Raipur Rani",
    "Rajound",
    "Rania",
    "Ratia",
    "Rewari",
    "Rohtak",
    "Sadhaura",
    "Safidon",
    "Saha",
    "Samalkha",
    "Sampla",
    "Shahbad",
    "Sirsa",
    "Siwani",
    "Sohna",
    "Sonipat",
    "Taraori",
    "Thanesar (Kurukshetra)",
    "Tohana",
    "Tosham",
    "Uchana",
    "Yamunanagar"
  ],
  "Bihar": [
    "Alamnagar",
    "Amarpur",
    "Araria",
    "Areraj",
    "Arrah",
    "Arwal",
    "Asarganj",
    "Asthawan",
    "Aurangabad (Bihar)",
    "Bagaha",
    "Bahadurganj",
    "Bairgania",
    "Bakhtiarpur",
    "Banka",
    "Barahiya",
    "Barauli",
    "Barbigha",
    "Barh",
    "Barsoi",
    "Begusarai",
    "Belsand",
    "Benipatti",
    "Bettiah",
    "Bhabua (Kaimur)",
    "Bhagalpur",
    "Bihar Sharif",
    "Bihta",
    "Bikramganj",
    "Birpur",
    "Bodh Gaya",
    "Bousi",
    "Buxar",
    "Chakai",
    "Chakia (Purvi Champaran)",
    "Chanpatia",
    "Chhapra",
    "Dalsinghsarai",
    "Danapur",
    "Darbhanga",
    "Daudnagar",
    "Dehri",
    "Dhaka",
    "Dighwara",
    "Dumra",
    "Dumraon",
    "Ekma",
    "Fatwah",
    "Forbesganj",
    "Gaya",
    "Gidhaur",
    "Gogri Jamalpur",
    "Goh",
    "Gopalganj",
    "Hajipur",
    "Haveli Kharagpur",
    "Hilsa",
    "Hisua",
    "Islampur (Nalanda)",
    "Jagdishpur",
    "Jamalpur",
    "Jamui",
    "Jehanabad",
    "Jhajha",
    "Jhanjharpur",
    "Jogbani",
    "Kahalgaon",
    "Kataiya",
    "Katihar",
    "Katoria",
    "Khagaria",
    "Khagaul",
    "Kishanganj",
    "Koilwar",
    "Lakhisarai",
    "Lalganj (Vaishali)",
    "Madhepura",
    "Madhubani",
    "Maharajganj (Siwan)",
    "Mahnar",
    "Mahua",
    "Mairwa",
    "Makhdumpur",
    "Maner",
    "Manihari",
    "Manpur",
    "Marhaura",
    "Masaurhi",
    "Mirganj",
    "Mokama",
    "Motihari",
    "Munger",
    "Murliganj",
    "Muzaffarpur",
    "Nabinagar",
    "Narkatiaganj",
    "Naugachia",
    "Nawada",
    "Nirmali",
    "Nokha",
    "Pakribarawan",
    "Patna",
    "Patori",
    "Phulparas",
    "Piro",
    "Pupri",
    "Purnia",
    "Rafiganj",
    "Rajauli",
    "Rajgir",
    "Ramnagar",
    "Raxaul",
    "Revelganj",
    "Rosera",
    "Saharsa",
    "Samastipur",
    "Sasaram",
    "Shahpur",
    "Sheikhpura",
    "Sheohar",
    "Sherghati",
    "Silao",
    "Singheshwar",
    "Sitamarhi",
    "Siwan",
    "Sono",
    "Sonpur",
    "Sultanganj",
    "Supaul",
    "Suryagarha",
    "Tajpur",
    "Tarapur",
    "Tekari",
    "Thakurganj",
    "Triveniganj",
    "Vikramganj",
    "Warsaliganj",
    "Wazirganj"
  ],
  "Kerala": [
    "Adimali",
    "Adoor",
    "Alappuzha",
    "Aluva",
    "Angamaly",
    "Attingal",
    "Chalakudy",
    "Changanassery",
    "Chengannur",
    "Cherthala",
    "Chittur-Thathamangalam",
    "Eloor",
    "Erattupetta",
    "Ettumanoor",
    "Guruvayur",
    "Iritty",
    "Kalamassery",
    "Kalpetta",
    "Kanhangad",
    "Kannur",
    "Karunagappally",
    "Kasaragod",
    "Kattappana",
    "Kayamkulam",
    "Kochi",
    "Kodungallur",
    "Kollam",
    "Koothattukulam",
    "Koothuparamba",
    "Kothamangalam",
    "Kottakkal",
    "Kottarakkara",
    "Kottayam",
    "Koyilandy",
    "Kozhikode",
    "Kunnamkulam",
    "Malappuram",
    "Mananthavady",
    "Manjeri",
    "Mannarkkad",
    "Mattannur",
    "Mavelikkara",
    "Munnar",
    "Muvattupuzha",
    "Nedumangad",
    "Neyyattinkara",
    "Nilambur",
    "Nileshwaram",
    "North Paravur",
    "Ottapalam",
    "Pala",
    "Palakkad",
    "Pandalam",
    "Paravur",
    "Pathanamthitta",
    "Payyanur",
    "Perinthalmanna",
    "Perumbavoor",
    "Piravom",
    "Ponnani",
    "Punalur",
    "Shornur",
    "Sulthan Bathery",
    "Taliparamba",
    "Thalassery",
    "Thiruvalla",
    "Thiruvananthapuram",
    "Thodupuzha",
    "Thrissur",
    "Tirur",
    "Tripunithura",
    "Vaikom",
    "Varkala",
    "Vatakara"
  ],
  "Odisha": [
    "Anandapur",
    "Angul",
    "Aska",
    "Athagarh",
    "Attabira",
    "Balasore",
    "Balugaon",
    "Banapur",
    "Banki",
    "Barbil",
    "Bargarh",
    "Baripada",
    "Basudevpur",
    "Bellaguntha",
    "Belpahar",
    "Berhampur",
    "Bhadrak",
    "Bhanjanagar",
    "Bhawanipatna",
    "Bhuban",
    "Bhubaneswar",
    "Bolangir",
    "Boudh",
    "Brajrajnagar",
    "Chandbali",
    "Chhatrapur",
    "Choudwar",
    "Cuttack",
    "Damanjodi",
    "Deogarh",
    "Dhamra",
    "Dhenkanal",
    "Digapahandi",
    "Gopalpur",
    "Gumia",
    "Gunupur",
    "Hindustan",
    "Hinjilicut",
    "Jagatsinghpur",
    "Jajpur",
    "Jaleswar",
    "Jatani",
    "Jeypore",
    "Jharsuguda",
    "Joda",
    "Junagarh",
    "Kakatpur",
    "Kamakhyanagar",
    "Kantabanji",
    "Karanjia",
    "Kendrapara",
    "Kendujhar",
    "Kesinga",
    "Khordha",
    "Konark",
    "Koraput",
    "Malkangiri",
    "Nabarangpur",
    "Nayagarh",
    "Nilagiri",
    "Nimapada",
    "Nuapada",
    "Padampur",
    "Pallahara",
    "Paradeep",
    "Paralakhemundi",
    "Patnagarh",
    "Phulbani",
    "Pipili",
    "Puri",
    "Rairangpur",
    "Rajgangpur",
    "Rayagada",
    "Rourkela",
    "Salipur",
    "Sambalpur",
    "Soro",
    "Subarnapur (Sonepur)",
    "Sunabeda",
    "Sundargarh",
    "Talcher",
    "Titlagarh",
    "Umerkote",
    "Vyasanagar (Jajpur Road)"
  ],
  "Assam": [
    "Abhayapuri",
    "Amguri",
    "Badarpur",
    "Barpeta",
    "Barpeta Road",
    "Basugaon",
    "Bihpuria",
    "Bijni",
    "Bilasipara",
    "Biswanath Chariali",
    "Bokakhat",
    "Bongaigaon",
    "Chabua",
    "Dergaon",
    "Dhekiajuli",
    "Dhemaji",
    "Dhing",
    "Dhubri",
    "Dibrugarh",
    "Digboi",
    "Diphu",
    "Doboka",
    "Doomdooma",
    "Gauripur",
    "Ghilamara",
    "Goalpara",
    "Gohpur",
    "Golaghat",
    "Gossaigaon",
    "Guwahati",
    "Haflong",
    "Hailakandi",
    "Hajo",
    "Hojai",
    "Howly",
    "Jonai",
    "Jorhat",
    "Kampuz",
    "Karimganj",
    "Kharupetia",
    "Kokrajhar",
    "Koliabor",
    "Lala",
    "Lanka",
    "Lumding",
    "Mangaldai",
    "Margherita",
    "Mariani",
    "Moranhat",
    "Morigaon",
    "Nagaon",
    "Naharkatiya",
    "Nalbari",
    "Namrup",
    "Narayanpur",
    "Nazira",
    "North Guwahati",
    "North Lakhimpur",
    "Palasbari",
    "Pathsala",
    "Raha",
    "Ramkrishna Nagar",
    "Rangapara",
    "Rangia",
    "Rowta",
    "Sapatgram",
    "Sarthebari",
    "Sarupathar",
    "Silapathar",
    "Silchar",
    "Sivasagar",
    "Sonari",
    "Sualkuchi",
    "Tangla",
    "Tezpur",
    "Tihu",
    "Tinsukia",
    "Titabor",
    "Udalguri"
  ],
  "Jharkhand": [
    "Bagodar",
    "Barharwa",
    "Barhi",
    "Barkakana",
    "Basukinath",
    "Bermo",
    "Bokaro Steel City",
    "Bundu",
    "Chaibasa",
    "Chakradharpur",
    "Chandrapura",
    "Chatra",
    "Chauparan",
    "Chirkunda",
    "Deoghar",
    "Dhanbad",
    "Dhanwar",
    "Dumka",
    "Dumri",
    "Garhwa",
    "Ghatshila",
    "Giridih",
    "Godda",
    "Gomia",
    "Gomoh",
    "Gumla",
    "Hazaribagh",
    "Hunterganj",
    "Jadugora",
    "Jamshedpur",
    "Jamtara",
    "Jharia",
    "Jhumri Telaiya",
    "Kanke",
    "Katras",
    "Kharkhari",
    "Khunti",
    "Koderma",
    "Latehar",
    "Lohardaga",
    "Madhupur",
    "Mahuadanr",
    "Medininagar (Daltonganj)",
    "Mihijam",
    "Musabani",
    "Nagar Untari",
    "Netarhat",
    "Nirsa",
    "Ormanjhi",
    "Pakur",
    "Patratu",
    "Phusro",
    "Rajmahal",
    "Ramgarh",
    "Ranchi",
    "Sahibganj",
    "Saraikela",
    "Simaria",
    "Simdega",
    "Sindri",
    "Tandwa",
    "Tenu Dam",
    "Tisri"
  ],
  "Chhattisgarh": [
    "Abhanpur",
    "Ahiwara",
    "Akaltara",
    "Ambikapur",
    "Antagarh",
    "Arang",
    "Bacheli",
    "Bagbahara",
    "Bagicha",
    "Baikunthpur (Koriya)",
    "Balod",
    "Baloda Bazar",
    "Balrampur (Chhattisgarh)",
    "Basna",
    "Bemetara",
    "Berla",
    "Bhairamgarh",
    "Bhaiyathan",
    "Bhanupratappur",
    "Bhatapara",
    "Bhilai",
    "Bhilai Charoda",
    "Bhopalpatnam",
    "Bijapur",
    "Bilaspur",
    "Bilha",
    "Bodla",
    "Champa",
    "Chhuria",
    "Chirmiri",
    "Dabhra",
    "Dalli-Rajhara",
    "Dantewada",
    "Dhamtari",
    "Dharamjaigarh",
    "Dipka",
    "Dongargaon",
    "Dongargarh",
    "Durg",
    "Gandai",
    "Gariaband",
    "Gaurela",
    "Geedam",
    "Gharghoda",
    "Gobranawapara",
    "Gunderdehi",
    "Jagdalpur",
    "Jaijaipur",
    "Jamul",
    "Janjgir",
    "Jashpur Nagar",
    "Kanker",
    "Katghora",
    "Kawardha",
    "Keshkal",
    "Khairagarh",
    "Kharsia",
    "Kirandul",
    "Kondagaon",
    "Konta",
    "Korba",
    "Korba West",
    "Kota (Chhattisgarh)",
    "Kumhari",
    "Kunkuri",
    "Kurud",
    "Kusmunda",
    "Lormi",
    "Mahasamund",
    "Manendragarh",
    "Masturi",
    "Mungeli",
    "Nagri",
    "Naila Champa",
    "Narayanpur",
    "Nawagarh",
    "Pakhanjur",
    "Pamgarh",
    "Pandariya",
    "Patan (Durg)",
    "Pathalgaon",
    "Pathariya",
    "Pendra",
    "Pithora",
    "Pratappur",
    "Raigarh",
    "Raipur",
    "Rajim",
    "Rajnandgaon",
    "Ramanujganj",
    "Ratanpur",
    "Saja",
    "Sakti",
    "Samri",
    "Saraipali",
    "Sarangarh",
    "Simga",
    "Sitapur",
    "Sukma",
    "Surajpur",
    "Takhatpur",
    "Tilda Newra",
    "Wadrafnagar"
  ],
  "Uttarakhand": [
    "Almora",
    "Badrinath",
    "Bageshwar",
    "Baijnath",
    "Bajpur",
    "Barkot",
    "Berinag",
    "Bhagwanpur",
    "Bhimtal",
    "Bhowali",
    "Chamba (Uttarakhand)",
    "Chamoli",
    "Champawat",
    "Chaukhutiya",
    "Chinyalisaur",
    "Dehradun",
    "Devprayag",
    "Dharchula",
    "Didihat",
    "Doiwala",
    "Dunda",
    "Dwarahat",
    "Gadarpur",
    "Gangotri",
    "Gauchar",
    "Gopeshwar",
    "Haldwani",
    "Haridwar",
    "Herbertpur",
    "Jaspur",
    "Joshimath",
    "Karnaprayag",
    "Kashipur",
    "Kausani",
    "Kedarnath",
    "Khatima",
    "Kichha",
    "Kotdwar",
    "Laksar",
    "Lalkuan",
    "Lansdowne",
    "Lohaghat",
    "Manglaur",
    "Mukteshwar",
    "Munsyari",
    "Mussoorie",
    "Nainital",
    "Narendra Nagar",
    "New Tehri",
    "Pauri",
    "Pithoragarh",
    "Purola",
    "Ramnagar",
    "Ranikhet",
    "Rikhanikhal",
    "Rishikesh",
    "Roorkee",
    "Rudraprayag",
    "Rudrapur",
    "Shaktifarm",
    "Sitarganj",
    "Someshwar",
    "Srinagar (Uttarakhand)",
    "Tanakpur",
    "Tehri",
    "Uttarkashi",
    "Vikasnagar",
    "Yamunotri"
  ],
  "Himachal Pradesh": [
    "Amb",
    "Anni",
    "Arki",
    "Baddi",
    "Baijnath (Himachal)",
    "Banjar",
    "Barsar",
    "Bharmour",
    "Bhoranj",
    "Bhuntar",
    "Bilaspur (Himachal)",
    "Chamba",
    "Chopal",
    "Chowari",
    "Dalhousie",
    "Dehra Gopipur",
    "Dharamshala",
    "Gagret",
    "Ghumarwin",
    "Hamirpur",
    "Haroli",
    "Jawalamukhi",
    "Jogindernagar",
    "Jubbal",
    "Kalpa",
    "Kandaghat",
    "Kangra",
    "Karsog",
    "Kasauli",
    "Kaza",
    "Keylong",
    "Killar (Pangi)",
    "Kotkhai",
    "Kullu",
    "Kullu Valley",
    "Kumarsain",
    "Manali",
    "Mandi",
    "Mehatpur",
    "Nadaun",
    "Nagrota Bagwan",
    "Nahan",
    "Nalagarh",
    "Nurpur",
    "Palampur",
    "Paonta Sahib",
    "Parwanoo",
    "Pooh",
    "Rajgarh (Himachal)",
    "Rampur Bushahr",
    "Reckong Peo",
    "Rewalsar",
    "Rohru",
    "Sarahan",
    "Sarkaghat",
    "Shahpur",
    "Shimla",
    "Shri Naina Devi",
    "Solan",
    "Sujanpur Tira",
    "Sundarnagar",
    "Swarghat",
    "Theog",
    "Udaipur (Lahaul)",
    "Una"
  ],
  "Jammu and Kashmir": [
    "Akhnoor",
    "Anantnag",
    "Awantipora",
    "Bandipora",
    "Banihal",
    "Baramulla",
    "Basholi",
    "Batote",
    "Beerwah",
    "Bhaderwah",
    "Bijbehara",
    "Billawar",
    "Bishnah",
    "Budgam",
    "Chadoora",
    "Charar-i-Sharief",
    "Chenani",
    "Damhal Hanjipora",
    "Devsar",
    "Doda",
    "Dooru",
    "Ganderbal",
    "Gandoh",
    "Gool",
    "Gulmarg",
    "Gurez",
    "Hajan",
    "Handwara",
    "Hiranagar",
    "Jammu",
    "Jourian",
    "Kalakote",
    "Kangan",
    "Karnah",
    "Kathua",
    "Katra",
    "Katra Vaishno Devi",
    "Khansahib",
    "Khour",
    "Kishtwar",
    "Kokernag",
    "Kotranka",
    "Kulgam",
    "Kupwara",
    "Langate",
    "Magam",
    "Mahore",
    "Majalta",
    "Mandi (Poonch)",
    "Mendhar",
    "Nowshera",
    "Pahalgam",
    "Pampore",
    "Pattan",
    "Poonch",
    "Pouni",
    "Pulwama",
    "Qazigund",
    "Rafiabad",
    "Rajouri",
    "Ramban",
    "Ramnagar (Udhampur)",
    "Reasi",
    "RS Pura",
    "Samba",
    "Shopian",
    "Sogam",
    "Sopore",
    "Srinagar",
    "Sumbal",
    "Sunderbani",
    "Surankote",
    "Tangmarg",
    "Thanamandi",
    "Thathri",
    "Tral",
    "Udhampur",
    "Uri",
    "Yaripora"
  ],
  "Goa": [
    "Agassaim",
    "Aldona",
    "Anjuna",
    "Benaulim",
    "Bicholim",
    "Calangute",
    "Canacona",
    "Candolim",
    "Chicalim",
    "Colva",
    "Cortalim",
    "Cuncolim",
    "Curchorem",
    "Dabolim",
    "Dharbandora",
    "Fatorda",
    "Mandrem",
    "Mapusa",
    "Margao",
    "Morjim",
    "Navelim",
    "Panaji",
    "Pernem",
    "Ponda",
    "Porvorim",
    "Quepem",
    "Sanguem",
    "Sanquelim",
    "Santa Cruz",
    "Siolim",
    "Tivim",
    "Valpoi",
    "Vasco da Gama",
    "Verna"
  ],
  "Tripura": [
    "Agartala",
    "Amarpur (Tripura)",
    "Ambassa",
    "Belonia",
    "Bishalgarh",
    "Dharmanagar",
    "Gandacherra",
    "Jirania",
    "Kailashahar",
    "Kanchanpur",
    "Khowai",
    "Kumarghat",
    "Melaghar",
    "Mohanpur",
    "Panisagar",
    "Ranirbazar",
    "Sabroom",
    "Santirbazar",
    "Sonamura",
    "Teliamura",
    "Udaipur (Tripura)"
  ],
  "Meghalaya": [
    "Amlarem",
    "Ampati",
    "Baghmara",
    "Byrnihat",
    "Cherrapunji (Sohra)",
    "Dadenggre",
    "Dawki",
    "Jowai",
    "Khliehriat",
    "Madanrting",
    "Mairang",
    "Mawkyrwat",
    "Mawlai",
    "Nongpoh",
    "Nongstoin",
    "Pynursla",
    "Resubelpara",
    "Rongjeng",
    "Shillong",
    "Tura",
    "Williamnagar"
  ],
  "Manipur": [
    "Bishnupur",
    "Chandel",
    "Churachandpur",
    "Imphal",
    "Jiribam",
    "Kakching",
    "Kamjong",
    "Kangpokpi",
    "Kumbi",
    "Lilong",
    "Mayang Imphal",
    "Moirang",
    "Moreh",
    "Nambol",
    "Noney",
    "Pherzawl",
    "Senapati",
    "Sugnu",
    "Tamenglong",
    "Tengnoupal",
    "Thoubal",
    "Ukhrul",
    "Wangoi",
    "Yairipok"
  ],
  "Mizoram": [
    "Aizawl",
    "Bairabi",
    "Champhai",
    "Darlawn",
    "Hnahthial",
    "Khawzawl",
    "Kolasib",
    "Lawngtlai",
    "Lunglei",
    "Mamit",
    "North Vanlaiphai",
    "Saiha",
    "Saitual",
    "Serchhip",
    "Thenzawl",
    "Tlabung",
    "Vairengte",
    "Zawlnuam"
  ],
  "Nagaland": [
    "Aboi",
    "Chumoukedima",
    "Dimapur",
    "Jalukie",
    "Kiphire",
    "Kohima",
    "Longleng",
    "Mangkolemba",
    "Medziphema",
    "Mokokchung",
    "Mon",
    "Naganimora",
    "Niuland",
    "Noklak",
    "Peren",
    "Pfütsero",
    "Phek",
    "Shamator",
    "Tizit",
    "Tseminyu",
    "Tuensang",
    "Wokha",
    "Zunheboto"
  ],
  "Arunachal Pradesh": [
    "Along (Aalo)",
    "Anini",
    "Basar",
    "Bhalukpong",
    "Boleng",
    "Bomdila",
    "Changlang",
    "Daporijo",
    "Deomali",
    "Dirang",
    "Hawai",
    "Itanagar",
    "Jairampur",
    "Khonsa",
    "Koloriang",
    "Lemmi",
    "Likabali",
    "Longding",
    "Miao",
    "Naharlagun",
    "Namsai",
    "Pangin",
    "Pasighat",
    "Raga",
    "Roing",
    "Seppa",
    "Tato",
    "Tawang",
    "Tezu",
    "Yingkiong",
    "Ziro"
  ],
  "Sikkim": [
    "Chungthang",
    "Gangtok",
    "Geyzing",
    "Jorethang",
    "Lachen",
    "Lachung",
    "Mangan",
    "Namchi",
    "Nayabazar",
    "Pakyong",
    "Rangpo",
    "Ravangla",
    "Rhenock",
    "Rongli",
    "Singtam",
    "Soreng",
    "Yuksom"
  ],
  "Chandigarh": [
    "Chandigarh",
    "Manimajra"
  ],
  "Dadra and Nagar Haveli and Daman and Diu": [
    "Amli",
    "Bhimpore",
    "Dadra",
    "Daman",
    "Diu",
    "Dunetha",
    "Kachigam",
    "Naroli",
    "Silvassa"
  ],
  "Ladakh": [
    "Diskit",
    "Dras",
    "Kargil",
    "Khalatse",
    "Leh",
    "Nubra",
    "Nyoma",
    "Padum",
    "Sankoo",
    "Zanskar"
  ],
  "Puducherry": [
    "Ariyankuppam",
    "Bahour",
    "Karaikal",
    "Mahe",
    "Ozhukarai",
    "Puducherry",
    "Villianur",
    "Yanam"
  ],
  "Andaman and Nicobar Islands": [
    "Bambooflat",
    "Campbell Bay",
    "Car Nicobar",
    "Diglipur",
    "Garacharma",
    "Havelock Island (Swaraj Dweep)",
    "Hut Bay",
    "Mayabunder",
    "Neil Island",
    "Port Blair",
    "Rangat"
  ],
  "Lakshadweep": [
    "Agatti",
    "Amini",
    "Andrott",
    "Bitra",
    "Chetlat",
    "Kadmat",
    "Kalpeni",
    "Kavaratti",
    "Kiltan",
    "Minicoy"
  ]
};

export const getNormalizedStateKey = (state) => {
  if (!state || typeof state !== 'string') return null;
  const clean = state.trim().toLowerCase();
  return Object.keys(INDIAN_STATES_AND_CITIES).find(
    s => s.trim().toLowerCase() === clean
  ) || null;
};

export const getStateList = () => {
  const others = Object.keys(INDIAN_STATES_AND_CITIES).filter(s => s !== "Gujarat").sort();
  return ["Gujarat", ...others, "Other"];
};

export const getCitiesForState = (state) => {
  const matchedKey = getNormalizedStateKey(state);
  if (!matchedKey || matchedKey === "Other") {
    return ["Other"];
  }
  return [...INDIAN_STATES_AND_CITIES[matchedKey], "Other"];
};

export const getStateOptions = (currentState) => {
  const list = getStateList();
  if (currentState && currentState.trim()) {
    const cleanCurrent = currentState.trim();
    const matchedKey = getNormalizedStateKey(cleanCurrent);
    if (!matchedKey && cleanCurrent !== "Other") {
      const otherIdx = list.indexOf("Other");
      if (otherIdx !== -1) {
        list.splice(otherIdx, 0, cleanCurrent);
      } else {
        list.push(cleanCurrent);
      }
    }
  }
  return list.map(s => ({ label: s, value: s }));
};

export const getCityOptions = (state, currentCity) => {
  const list = [...getCitiesForState(state)];
  if (currentCity && typeof currentCity === 'string' && currentCity.trim()) {
    const trimmed = currentCity.trim();
    const exists = list.some(c => c.toLowerCase() === trimmed.toLowerCase());
    if (!exists) {
      const otherIdx = list.indexOf("Other");
      if (otherIdx !== -1) {
        list.splice(otherIdx, 0, trimmed);
      } else {
        list.push(trimmed);
      }
    }
  }
  return list.map(c => ({ label: c, value: c }));
};
